import axios from 'utils/axios';
import { REFUND_REQUEST } from 'utils/axios/endpoints';

export const handleRefundRequestList = async body => {
  const res = await axios.post(REFUND_REQUEST, body);
  return res;
};
